import { Component } from 'react';
import { connect } from 'react-redux';
import { getDefaultType, getDisplayName, getIsModuleEditable } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { buildFooterActions, BaseResponsiveFooterToolbar } from './BaseResponsiveFooterToolbar';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
// @ts-expect-error Untyped module
import { LAYOUT_SECTION_TRACKING } from 'ContentEditorUI/lib/layoutSection/constants';
// @ts-expect-error Untyped module
import { logLayoutSectionEvent } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  return {
    moduleType: id ? getDefaultType(state, id) : undefined,
    displayName: id ? getDisplayName(state, id) : undefined,
    isEditable: id ? getIsModuleEditable(state, id) : undefined,
    selectedItemId: getSelectedItemId(state),
    isInNonDefaultBreakpointMode: getIsInNonDefaultBreakpointMode(state)
  };
};
class ResponsiveFooterToolbar extends Component {
  render() {
    const {
      id,
      displayName,
      moduleType,
      top,
      left,
      onDropdownOpenChange,
      responsiveSize = DEFAULT_RESPONSIVE_SIZE,
      dispatch,
      bus,
      isEditable,
      isInNonDefaultBreakpointMode
    } = this.props;
    const handleDropdownOpenChange = isOpen => {
      if (onDropdownOpenChange) {
        onDropdownOpenChange(isOpen);
        if (isOpen) {
          bus.dispatchActionToEventBus(logLayoutSectionEvent(LAYOUT_SECTION_TRACKING.EDIT_FOOTER));
        }
      }
    };
    return /*#__PURE__*/_jsx(BaseResponsiveFooterToolbar, {
      actions: buildFooterActions({
        moduleId: id,
        moduleType,
        isInNonDefaultBreakpointMode,
        dispatch,
        bus,
        isEditable: !!isEditable
      }),
      onDropdownOpenChange: handleDropdownOpenChange,
      insetBlockStart: `${Math.round(top)}px`,
      insetInlineStart: `${Math.round(left)}px`,
      position: "absolute",
      responsiveSize: responsiveSize,
      handleTooltip: displayName,
      iconUse: "pinned"
    });
  }
}
const mapDispatchToProps = dispatch => ({
  dispatch
});
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(ResponsiveFooterToolbar);